import {
  IApplicationRelationshipLevels,
  IShipperRelationshipTypes,
  Maybe,
} from 'types/graphqlTypes'
import { IShipperRelationshipInfoFragment } from '../graphql/ShipperRelationshipInfoFragment'

export interface IGroupedShipperRelationships {
  accountManager: Maybe<IShipperRelationshipInfoFragment>
  primaryAccountOpsRep: Maybe<IShipperRelationshipInfoFragment>
  secondaryAccountOpsReps: Maybe<IShipperRelationshipInfoFragment[]>
  primaryCarrierOpsRep: Maybe<IShipperRelationshipInfoFragment>
  secondaryCarrierOpsReps: Maybe<IShipperRelationshipInfoFragment[]>
  salesExecutive: Maybe<IShipperRelationshipInfoFragment>
  contactReferer: Maybe<IShipperRelationshipInfoFragment>
  financeRep: Maybe<IShipperRelationshipInfoFragment>
}
/**
 * @description get shipper relationships grouped by their type and level
 */
export const groupShipperRelationships = (
  shipperRelationships?: IShipperRelationshipInfoFragment[]
): IGroupedShipperRelationships => {
  return {
    accountManager: shipperRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === IShipperRelationshipTypes.account_manager
    ),
    primaryAccountOpsRep: shipperRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === IShipperRelationshipTypes.account_ops
    ),
    secondaryAccountOpsReps: shipperRelationships?.filter(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.secondary &&
        cr.relationshipType === IShipperRelationshipTypes.account_ops
    ),
    primaryCarrierOpsRep: shipperRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === IShipperRelationshipTypes.carrier_ops
    ),
    secondaryCarrierOpsReps: shipperRelationships?.filter(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.secondary &&
        cr.relationshipType === IShipperRelationshipTypes.carrier_ops
    ),
    salesExecutive: shipperRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === IShipperRelationshipTypes.sales_rep
    ),
    contactReferer: shipperRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === IShipperRelationshipTypes.contact_referer
    ),
    financeRep: shipperRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === IShipperRelationshipTypes.finance_rep
    ),
  }
}
